<template>
  <div class="meeting">
    <div class="zxzx_div">
      <el-menu
        :default-active="routePath"
        :default-openeds="['1']"
        active-text-color="#143372"
        :router="true"
      >
        <el-menu-item class="title">
          <span slot="title">会议论坛</span>
        </el-menu-item>
		
		<el-menu-item index="/meeting/introduce">
		  <span slot="title">论坛简介</span>
		</el-menu-item>
		
       <!-- 
	   <el-submenu index="1">
          <template slot="title">
            <span>论坛简介</span>
          </template>
          <el-menu-item class="child" index="/meeting/introduce"
            >论坛介绍</el-menu-item
          >
          <el-menu-item class="child" index="/meeting/currentForum" route=""
            >本届论坛</el-menu-item
          >
          <el-menu-item class="child" index="/meeting/historyEvolution"
            >历史沿革</el-menu-item
          >
        </el-submenu> 
		-->
       <!--
		<el-menu-item index="/meeting/info">
          <span slot="title">论坛资讯</span>
        </el-menu-item>
        <el-menu-item index="/meeting/expert">
          <span slot="title">论坛专家</span>
        </el-menu-item> 
		-->
      </el-menu>
    </div>

    <div class="right_content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "meeting", // 会议论坛
  components: {},
  data() {
    return {
      tabName: "",
      activeNames: "1",
      collapseH: "1",
      eventList: [],
      routePath: "",
    };
  },
  computed: {
    getEventRouteLiName() {
      return this.$store.state.allRouteLiName;
    },
  },
  watch: {
    getEventRouteLiName(val) {
      if (val === "ltjj") {
        val = "ltjs";
      }
      this.tabName = val;
    },
    $route(val) {
    },
  },
  created() {},
  activated() {
    let path = this.$route.path;
    this.routePath = path;
    if (path === "/meeting/info/details") {
      this.routePath = "/meeting/info"
    }
    // let sessionStore = JSON.parse(sessionStorage.getItem("mainStore"));
    // if (sessionStore && sessionStore.name) {
    //   switch (sessionStore.name) {
    //     case "ltjj":
    //       this.tabName = "ltjs";
    //       break;
    //     case "ltzx":
    //       this.tabName = sessionStore.name;
    //       break;
    //     case "ltzj":
    //       this.tabName = sessionStore.name;
    //       break;
    //     default:
    //       this.tabName = "ltjs";
    //   }
    // } else {
    //   this.tabName = "ltjs";
    // }
  },
  mounted() {},
  methods: {
    liName(name) {
      this.$store.commit("SET_ROUTE_LI_NAME", name);
      this.tabName = name;
      sessionStorage.setItem("mainStore", JSON.stringify({ name: name }));
    },
  },
};
</script>
<style lang="scss">
.meeting {
  .zxzx_ul {
    //height: 500px;
    .el-collapse-item__content {
      padding: 0;
    }
    .el-collapse-item__header {
      height: 64px;
      color: #999999;
      font-weight: bold;
      border-bottom: 1px dashed #f2f2f2;
      line-height: 64px;
      text-indent: 31px;
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      border-bottom: 1px dashed #f2f2f2;
    }
    .el-collapse-item__arrow {
      font-size: 14px;
      width: 14px;
      color: #143277;
      margin: 0 24px 0 auto;
    }
    .el-icon-arrow-right:before {
      content: "\e791";
      margin-left: -31px;
    }
    .el-collapse-item__header.is-active {
      // color: #143277;
    }
  }
  .el-menu-item {
    padding-left: 0 !important;
    color: #999999;
    font-weight: bold;
    width: 238px;
    height: 64px;
    line-height: 64px;
    text-indent: 31px;
    font-size: 16px;
   // border-bottom: 1px dashed #f2f2f2;
    &:hover,
    &:focus {
      background-color: #ffffff;
    }
  }
  .el-submenu__title {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px dashed #f2f2f2;
    padding-left: 31px !important;
    span {
      color: #999999;
      font-weight: bold;
      font-size: 16px;
    }
    &:hover,
    &:focus {
      background-color: #ffffff;
    }
  }

  .el-icon-arrow-down:before {
    content: "\e791";
    color: rgb(20, 50, 119);
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotateZ(90deg) !important;
  }
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #f2f2f2 !important;
  }
}
</style>
<style lang="scss" scoped>
.meeting {
  .liActive {
    color: #143372 !important;
  }
  .zxzx_div {
    width: 238px;
    //min-height: 256px;
	height: 128px;
    border-right: 1px solid #4bbc81;
    border-bottom: 1px solid #4bbc81;
    border-left: 1px solid #02b3ea;
    float: left;
    .title {
      font-size: 24px;
      font-weight: normal;
      color: #fff;
      cursor: default;
      background-image: linear-gradient(to right, #02b3ea, #4bbc81);
      border-bottom: none;
    }
    .child {
      font-size: 14px;
      text-indent: 54px;
    }
  }
  .right_content {
    width: 936px;
    float: right;
  }
}
</style>